import { render, staticRenderFns } from "./CustomerLayout.vue?vue&type=template&id=3c9423ea&"
import script from "./CustomerLayout.vue?vue&type=script&lang=ts&"
export * from "./CustomerLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports